import axios from 'axios';
import { useState } from "react";
import { useNavigate } from 'react-router-dom';

export default function PublicBackMethods() {
    const navigate = useNavigate();
    // const serverUrl = 'http://185.216.132.238/api/';
    const serverUrl = 'https://custpro.gov.sy/api/'


    // --- وظائف جلب البيانات الآمنة ---
    const getAccountToken = () => {
        const token = localStorage.getItem('accountToken');
        return (token && token !== "undefined" && token !== "null") ? token : null;
    };

    const getExpiresAt = () => {
        const expiry = localStorage.getItem('expiresAtUtc');
        return (expiry && expiry !== "undefined") ? expiry : null;
    };

    const getEstablishmentUid = () => {
        const uid = localStorage.getItem('establishmentUid');
        return (uid && uid !== "undefined") ? uid : null;
    };

    const [accountToken, setAccountToken] = useState(getAccountToken());
    const [expiresAt, setExpiresAt] = useState(getExpiresAt());
    const [establishmentUid, setEstablishmentUid] = useState(getEstablishmentUid());

    // --- حفظ البيانات عند تسجيل الدخول الناجح ---
    const savePublicLogin = (data, fieldUid) => {
        if (!data.accountToken || !fieldUid) return;

        localStorage.setItem('accountToken', data.accountToken);
        localStorage.setItem('expiresAtUtc', data.expiresAtUtc);
        localStorage.setItem('establishmentUid', fieldUid);

        setAccountToken(data.accountToken);
        setExpiresAt(data.expiresAtUtc);
        setEstablishmentUid(fieldUid);

        navigate(`/${fieldUid}`);
    };

    // --- تسجيل الخروج مع التوجيه الصحيح ---
    const publicLogout = () => {
        const currentEstId = establishmentUid;

        localStorage.removeItem('accountToken');
        localStorage.removeItem('expiresAtUtc');
        localStorage.removeItem('establishmentUid');

        setAccountToken(null);
        setExpiresAt(null);
        setEstablishmentUid(null);

        // التوجيه للداشبورد العام للمنشأة بدلاً من الصفحة الرئيسية
        if (currentEstId) {
            navigate(`/${currentEstId}`);
        } else {
            navigate(`/${currentEstId}`);
        }
    };

    // --- إعداد Axios بدون Headers ثابتة لتجنب الـ Bad Request ---
    const public_request = axios.create({
        baseURL: serverUrl,
        headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
        }
    });

    // إضافة التوكن ديناميكياً فقط إذا كان موجوداً
    public_request.interceptors.request.use(
        (config) => {
            const token = getAccountToken();
            // لا ترسل التوكن في طلب تسجيل الدخول نفسه لتجنب 400 Bad Request
            if (token && !config.url.includes('/login')) {
                config.headers['X-Account-Token'] = token;
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    // معالجة انتهاء الجلسة (401)
    public_request.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response?.status === 401) {
                publicLogout();
            }
            return Promise.reject(error);
        }
    );

    return {
        serverUrl,
        accountToken,
        expiresAt,
        establishmentUid,
        savePublicLogin,
        publicLogout,
        public_request,
        isLoggedIn: !!accountToken
    };
}